module.exports = __webpack_public_path__ + "img/idm-intro-header.3f893ce2.jpg";